import Device from '../utils/device';
import Cookie from '../utils/cookie';
import Trigger from '../event/trigger';
import MapMarkerComponent from './map-marker-component';

class MapComponent {
    static get UID () {
        if( !this.uid ){ this.uid = 0; }
        this.uid++;
        return this.uid;
    }

    static get ACCESS_TOKEN () {
        return "pk.eyJ1IjoiZGRibmV3emVhbGFuZCIsImEiOiJjazAzOHVrd2UwMXFyM2d0NmRnMzQ2bW4zIn0.HMNTRkklzvjK-5QpkyJZlQ";
    }

    static get EVENT () {
        return {
            MAP_OPEN: 'map-component-open',
            MAP_OPEN_COMPLETE: 'map-component-open-complete',
            MAP_CLOSE: 'map-component-close',
            MAP_CLOSE_COMPLETE: 'map-component-close-complete',
        }
    }

    constructor(el, index) {
        this.render(el, index);
        return this;
    }

    setCenter( index ) {
        var pin = this.pins[index];
        this.mapbox.setCenter( [ pin.lng, pin.lat ] );
        this.mapbox.setZoom( this.zoomLevelPin );
        this.window_RESIZE();
    }

    resetCenter() {
        this.mapbox.setCenter( this.centerLocation );
        this.mapbox.setZoom( this.zoomLevel );
        this.window_RESIZE();
    }

    show () {
        for ( var i = 0; i < this.pins.length; i++ ) {
            var pin = this.pins[i];
            pin.component.show( i / this.markersDivisorDelay );
        }
    }

    show_COMPLETE () {

    }

    hide () {
        for ( var i = 0; i < this.pins.length; i++ ) {
            var pin = this.pins[i];
            pin.component.hide( i / this.markersDivisorDelay );
        }

        TweenMax.to( this, this.pins.length / 3, { onComplete: this.hide_COMPLETE.bind(this) } )
    }

    hide_COMPLETE () {
        
        TweenMax.to( this.element, 0.6, { opacity: 0, ease: Cubic.easeOut, onComplete: function(){
            this.mapbox.setCenter( this.centerLocation );
            this.mapbox.setZoom( this.zoomLevel );

            TweenMax.to( this.element, 0.6, { opacity: 1, ease: Cubic.easeOut, delay: 0.2 });
        }.bind(this) } )
    }

    pin_ENTER( e ) {
        var target = e.currentTarget;
        for (var i = 0; i < this.pins.length; i++) {
            var marker = this.pins[i].component;
            if (marker.index != target.index) {
                marker.disable();
            }
        }
    }

    pin_LEAVE( e ) {
        var target = e.currentTarget;
        for (var i = 0; i < this.pins.length; i++) {
            var marker = this.pins[i].component;
            marker.enable();
        }
    }

    markers_LOADED () {
        for ( var i = 0; i < this.pins.length; i++ ) {
            var pin = this.pins[i];
            pin.marker = new mapboxgl.Marker( {element: MapMarkerComponent.getMarkerHTML( this.markerLayout, pin ) } ).setLngLat([pin.lng, pin.lat]).addTo(this.mapbox);
            pin.component = new MapMarkerComponent(pin, i);
            $(pin.component).on('ENTER', this.pin_ENTER.bind(this));
            $(pin.component).on('LEAVE', this.pin_LEAVE.bind(this));
        }

        this.window_RESIZE();
    }

    mapbox_LOADED () {
        TweenMax.to( this.viewport, 0.6, { opacity: 1, ease: Cubic.easeOut } );

        for ( var i = 0; i < this.markers.length; i++ ) {
            var marker = this.markers.eq(i);
            
            var data = {
                element: marker,
                index: i,
                id: 'marker-'+i,
                text: marker.attr('data-marker-component-text'),
                type: marker.attr('data-marker-component-type'),
                lat: parseFloat(marker.attr('data-marker-component-lat')),
                lng: parseFloat(marker.attr('data-marker-component-lng')),
                image: {
                    src: marker.attr('data-marker-component-pin'),
                    texture: null,
                },
                marker: null,
                component: null,
                map: this,
            }

            this.pins.push( data );
        }

        this.markers_LOADED();
    }

    window_RESIZE () {
        if(this.mapbox){
            this.mapbox.resize();
        }
    }

    render (el, index) {
        this.element = $(el);

        this.viewportID = 'c-map-component-viewport-' + MapComponent.UID;
        
        this.background = this.element.find('*[data-component="c-map-component-background"]');

        this.viewport = this.element.find('*[data-component="c-map-component-viewport"]');
        this.viewport.attr('id', this.viewportID);

        this.markers = this.element.find('*[data-component="c-marker-component"]');
        this.markerLayout = this.element.find('*[data-component="c-marker-layout"]');
        this.pins = [];
        this.markersToLoad = this.markers.length;
        this.markersLoaded = 0;
        this.markersDivisorDelay = 10;

        TweenMax.set( this.viewport, { opacity: 0 } );

        var bounds = [
            [174.327347399363257, -37.08711980493522], // Southwest coordinates
            [175.21222248586417, -36.6685302807333] // Northeast coordinates
        ];

        this.centerLocation = [parseFloat(this.element.attr('data-map-component-lng')), parseFloat(this.element.attr('data-map-component-lat'))];
        this.zoomLevel = parseFloat(this.element.attr('data-map-component-zoom'));
        this.zoomLevelPin = 13.211959869000877;

        mapboxgl.accessToken = MapComponent.ACCESS_TOKEN;
        this.mapbox = new mapboxgl.Map({
            container: this.viewportID,
            style: 'mapbox://styles/ddbnewzealand/ck038ybfi5tz11cmw80h3ol2e',
            center: this.centerLocation,
            zoom: this.zoomLevel,
            minZoom: parseFloat(this.element.attr('data-map-component-min-zoom')),
            maxZoom: parseFloat(this.element.attr('data-map-component-max-zoom')),
            maxBounds: bounds,
        });

        this.mapbox.on('load', this.mapbox_LOADED.bind(this));
        if(!window.map){
            window.map = this.mapbox;
        }

        $(window).on('resize', this.window_RESIZE.bind(this));
        this.window_RESIZE();

        window.test = this.mapbox;
    }
}

export default MapComponent;